var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "9px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38 -816 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.8958333333333 3.10143042912874  C 19.9652777777778 3.17165149544863  20 3.26137841352406  20 3.37061118335501  L 20 5.61768530559168  C 20 5.72691807542263  19.9652777777778 5.81664499349805  19.8958333333333 5.88686605981795  C 19.8263888888889 5.95708712613784  19.7376543209877 5.99219765929779  19.6296296296296 6  L 5.18518518518519 6  L 5.18518518518519 8.61378413524057  C 5.18518518518519 8.777633289987  5.11188271604938 8.89076723016905  4.96527777777778 8.95318595578674  C 4.81867283950617 9.01560468140442  4.68364197530864 8.9960988296489  4.56018518518519 8.89466840052016  L 0.115740740740741 4.79843953185956  C 0.0385802469135804 4.72041612483745  0 4.63068920676203  0 4.52925877763329  C 0 4.42002600780234  0.0385802469135804 4.32639791937581  0.115740740740741 4.24837451235371  L 4.56018518518519 0.105331599479844  C 4.68364197530864 -0.0039011703511076  4.81867283950617 -0.0273081924577392  4.96527777777778 0.0351105331599484  C 5.11188271604938 0.105331599479844  5.18518518518519 0.218465539661899  5.18518518518519 0.374512353706111  L 5.18518518518519 3  L 19.6296296296296 3  C 19.7376543209877 2.99609882964889  19.8263888888889 3.03120936280884  19.8958333333333 3.10143042912874  Z ",
    fillRule: "nonzero",
    fill: "#000000",
    stroke: "none",
    transform: "matrix(1 0 0 1 38 816 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageArrow);
export default __webpack_public_path__ + "static/media/page_arrow.9f1dd0a0b70c354b3be03ddeb29ea0c5.svg";
export { ForwardRef as ReactComponent };